import * as Sentry from '@sentry/react';

/**
 * 如果异步方法执行失败，则按指定间隔重试指定次数
 * @param fn 需要重试的异步方法
 * @param max 重试次数
 * @param interval 重试间隔
 * @returns 返回异步结果
 */
export function promiseRetry<T = any>(fn, max = 3, interval = 300) {
  return new Promise<T>((resolve, reject) => {
    let counts = 1;
    const executor = (res: typeof resolve, rej: typeof reject) => {
      fn()
        .then(res)
        .catch((error) => {
          if (counts >= max) {
            // 手动捕获异常
            Sentry.withScope(function setScope(scope) {
              scope.setLevel(Sentry.Severity.Warning);
              scope.setExtra('error', error);
              scope.setFingerprint(['多次重试最终失败']);
              Sentry.captureException(new Error(`promiseRetry 重试 ${max} 次还是失败了！`));
            });

            rej(error);
            return;
          }

          // 手动捕获异常
          Sentry.withScope(function setScope(scope) {
            scope.setLevel(Sentry.Severity.Info);
            scope.setExtra('error', error);
            scope.setFingerprint(['重试中']);
            Sentry.captureException(new Error(`promiseRetry 重试失败了 ${counts} 次`));
          });
          counts += 1;

          setTimeout(() => {
            executor(res, rej);
          }, interval);
        });
    };

    executor(resolve, reject);
  });
}
